<template>
  <div v-if="isArray" :class="{ 'details-child': isChild }">
    <ui-field
      v-if="itemValue.length"
      :label="itemKey && $t(`screening.${itemKey}`)"
      label-position="top"
    >
      <template v-if="itemKey === 'nationalities'">
        {{ countriesFullName }}
      </template>
      <template v-else-if="itemKey === 'profileImages'">
        <img
          v-for="(image, imageIndex) in itemValue"
          :src="image"
          :key="imageIndex"
          class="entity-picture"
        />
      </template>
      <template
        v-else-if="['datasets', 'dataSets', 'evidenceIds'].includes(itemKey)"
      >
        <ul class="reset-list">
          <li
            v-for="dataSet in itemValue"
            class="value-list-item"
            :key="dataSet"
          >
            {{ dataSet }}
          </li>
        </ul>
      </template>
      <template v-else-if="['aliases', 'addresses'].includes(itemKey)">
        <ol>
          <li v-for="(subKey, subIndex) in itemValue" :key="subIndex">
            {{ Object.values(subKey).filter(Boolean).join(", ") }}
          </li>
        </ol>
      </template>
      <template v-else>
        <screening-details-child
          v-for="(child, childIndex) in itemValue"
          :key="`${childIndex}`"
          :itemValue="child"
          is-child
        />
      </template>
    </ui-field>
  </div>
  <div v-else-if="isObject" :class="{ 'details-child': isChild }">
    <screening-details-child
      v-for="(childKey, childIndex) in Object.keys(itemValue)"
      :key="`${childIndex}-${childKey}`"
      :itemKey="childKey"
      :itemValue="itemValue[childKey]"
      is-child
    />
  </div>
  <div v-else>
    <ui-field
      v-if="itemValue"
      :label="$t(`screening.${itemKey}`)"
      label-position="top"
    >
      {{ itemValue }}
    </ui-field>
  </div>
</template>

<script>
import countryCodes from "../assets/isoCodes.json";

export default {
  props: {
    itemKey: String,
    itemValue: [Object, Array, String, Number],
    isChild: Boolean
  },
  name: "screening-details-child",
  computed: {
    isObject() {
      return (
        typeof this.itemValue === "object" &&
        !Array.isArray(this.itemValue) &&
        this.itemValue !== null
      );
    },
    isArray() {
      return Array.isArray(this.itemValue);
    },
    countriesFullName() {
      const countryNames = this.itemValue.map(countryCodeIso2 => {
        const countryIso3Code = countryCodes[countryCodeIso2];
        return this.$t(`countries.${countryIso3Code}`);
      });
      return countryNames.join(", ");
    }
  }
};
</script>

<style>
.details-child {
  margin-left: 1rem;
}
.reset-list {
  padding: 0;
  margin: 0;
}
.entity-picture {
  max-width: 40vw;
}
</style>
